import React, { FC, useCallback, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import { useParams } from 'react-router'
import { makeStyles } from '@mui/styles'
import { useHistory, useLocation } from 'react-router-dom'

import { Grid, ToggleButton, ToggleButtonGroup } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { Wallets } from './Wallets'
import { BankAccounts } from './BankAccounts'

import { getAssignedWalletsByUserRequest, getAssignedAccountsByUserRequest } from '../../../store/actions'

enum AccountsPanel {
  wallets = 'wallets',
  bankAccounts = 'bank-accounts',
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    backGroundColor: 'transparent',
    '& .MuiBox-root': {
      padding: 0,
    },
    '& .Mui-selected': {
      opacity: 1,
      color: theme.palette.secondary.main,
    },
  },
  tabPanel: {
    width: '100%',
    backgroundColor: 'transparent',
    '& > div': {
      width: '100%',
    },
  },
  buttonsWrap: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(1),

    '&div': {
      width: 300,
    },

    '& button': {
      backgroundColor: 'transparent',
      color: theme.palette.secondary.main,
      borderColor: theme.palette.secondary.main,
      textTransform: 'none',
      width: 150,
      height: 40,
      // borderRadius: 8,
    },

    '& .Mui-selected': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.primary.main,
      '&:hover': {
        color: theme.palette.primary.main,
        background: theme.palette.secondary.light,
      },
      '&.MuiButton-contained.Mui-disabled': {
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.secondary.main,
        opacity: 0.6,
      },
    },
  },
}))

export const UserSparlingAccounts: FC = () => {
  const history = useHistory()
  const location = useLocation()
  const dispatch = useDispatch()
  const { idSf, tab } = useParams<{ idSf: string; tab: string }>()

  const getActivePanelFromUrl = useCallback(() => {
    if (location.pathname.includes(AccountsPanel.bankAccounts)) {
      return AccountsPanel.bankAccounts
    }
    return AccountsPanel.wallets
  }, [location.pathname])

  const [activePanel, setActivePanel] = useState<AccountsPanel>(getActivePanelFromUrl())
  const classes = useStyles()

  const handleChange = useCallback(
    (e, panel) => {
      if (panel !== null) {
        history.push(`/users/${idSf}/${tab}/${panel}?page=1`)
      }
    },
    [history, idSf, tab],
  )

  useEffect(() => {
    setActivePanel(getActivePanelFromUrl())
  }, [getActivePanelFromUrl])

  useEffect(() => {
    if (!location.pathname.includes(AccountsPanel.wallets) && !location.pathname.includes(AccountsPanel.bankAccounts)) {
      history.push(`/users/${idSf}/${tab}/${AccountsPanel.wallets}?page=1`)
    }
    // eslint-disable-next-line
  }, [])

  useEffect(() => {
    if (idSf) {
      dispatch(getAssignedWalletsByUserRequest({ idSf, page: 1, count: 10 }))
      dispatch(getAssignedAccountsByUserRequest({ idSf, page: 1, count: 10 }))
    }
  }, [dispatch, idSf])

  return (
    <div className={classes.root}>
      <Grid container>
        <ToggleButtonGroup value={activePanel} exclusive onChange={handleChange} className={classes.buttonsWrap}>
          <ToggleButton value={AccountsPanel.wallets}>Wallets</ToggleButton>
          <ToggleButton value={AccountsPanel.bankAccounts}>Bank Accounts</ToggleButton>
        </ToggleButtonGroup>
      </Grid>

      <Grid container className={classes.tabPanel}>
        {activePanel === AccountsPanel.wallets && <Wallets />}
        {activePanel === AccountsPanel.bankAccounts && <BankAccounts />}
      </Grid>
    </div>
  )
}
